export default __webpack_public_path__ + "static/media/ic-format-italic.53caa568.svg";